import { formatPermissionName } from '../../utils/androidUtils';

interface PermissionBadgeProps {
  permission: string;
  category: 'normal' | 'dangerous' | 'special';
}

const categoryConfig: Record<
  'normal' | 'dangerous' | 'special',
  { color: string; bg: string; border: string }
> = {
  normal: {
    color: 'text-green-400',
    bg: 'bg-green-900/10',
    border: 'border-green-900/30',
  },
  dangerous: {
    color: 'text-yellow-400',
    bg: 'bg-yellow-900/10',
    border: 'border-yellow-900/30',
  },
  special: {
    color: 'text-red-400',
    bg: 'bg-red-900/10',
    border: 'border-red-900/30',
  },
};

function PermissionBadge({ permission, category }: PermissionBadgeProps) {
  const config = categoryConfig[category];

  return (
    <div
      className={`flex items-center gap-2 text-xs ${config.bg} border ${config.border} rounded px-2 py-1`}
    >
      <span className={config.color}>●</span>
      <span className="text-neutral-300">
        {formatPermissionName(permission)}
      </span>
    </div>
  );
}

interface PermissionGroupProps {
  title: string;
  count: number;
  color: string;
  permissions: string[];
  category: 'normal' | 'dangerous' | 'special';
}

export function PermissionGroup({
  title,
  count,
  color,
  permissions,
  category,
}: PermissionGroupProps) {
  if (permissions.length === 0) return null;

  return (
    <div>
      <div className={`text-xs font-medium ${color} mb-1.5`}>
        {title} ({count})
      </div>
      <div className="space-y-0.5">
        {permissions.map((perm, index) => (
          <PermissionBadge
            key={`${perm}-${index}`}
            permission={perm}
            category={category}
          />
        ))}
      </div>
    </div>
  );
}
